export default __webpack_public_path__ + "static/media/strasbourg10.0d04a255.jpg";